export class Select2 {
    init() {
        $(document).ready(() => {
            $('select.select2').select2();
        });
    }
}